import { render } from "./DashboardSwitch.vue?vue&type=template&id=ba728686&scoped=true"
import script from "./DashboardSwitch.vue?vue&type=script&lang=js"
export * from "./DashboardSwitch.vue?vue&type=script&lang=js"

import "./DashboardSwitch.vue?vue&type=style&index=0&id=ba728686&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba728686"]])

export default __exports__